/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcPaymentsV1AchEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_PAYMENTS_V1_ACH_EVENT_ENTITY_NAME = 'ixc.payments.v1.AchEvent';
export const ixcPaymentsV1AchEventEntity = new schema.Entity<IxcPaymentsV1AchEvent>(IXC_PAYMENTS_V1_ACH_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcPaymentsV1AchEvent) => `${entity.metadata?.eventId}` });

